import { SortOptions } from './CommonSortOptions';
import { OptionsDictionary } from './SortOptionDefinitions';

export const publishedConnectionSortOptions: OptionsDictionary = {
  'relevance': SortOptions.relevance,
  'name': SortOptions.name,
  'owner': SortOptions.owner,
  'projectName': SortOptions.projectName,
  'updated': SortOptions.updated,
};
